import React, { Children, ComponentProps, isValidElement, ReactElement, ReactNode } from 'react'
import type { IconProp } from '../../atoms/icon'

const INVALID_CHILDREN_ERROR = 'ActionBarActions can only contain `ActionBarAction` or `React.Fragment` as its children'

export interface ActionBarActionProps extends ComponentProps<'button'> {
  children: ReactNode
  icon?: IconProp
  disabled?: boolean
}

/**
 * Traverses and validates that all children are either fragments or ActionBar elements.
 */
export const getActionsFromChildren = (children: ReactNode): ReactElement<ActionBarActionProps>[] => {
  return Children.toArray(children).reduce<ReactElement<ActionBarActionProps>[]>((children, child) => {
    if (!isValidElement<{ children?: ReactNode }>(child)) {
      console.error(INVALID_CHILDREN_ERROR)
      return []
    }

    if (child.type === React.Fragment) {
      return children.concat(getActionsFromChildren(child.props.children))
    }

    return [...children, child as ReactElement<ActionBarActionProps>]
  }, [])
}
